// extracted by mini-css-extract-plugin
module.exports = {"base":"Logo_base__1QAZw"};